import { Message } from '@ai-sdk/react';
import React from 'react';
import ShareModal from './ShareModal';

interface ChatActionsProps {
  messages: Message[];
  isWidgetChat: boolean;
}

export const ChatActions: React.FC<ChatActionsProps> = ({
  messages,
  isWidgetChat,
}) => {
  if (isWidgetChat || !messages?.length) {
    return null;
  }

  return (
    <div className="bitte-absolute bitte-right-6 bitte-top-6 bitte-z-50">
      <ShareModal />
    </div>
  );
};
